import styled from "styled-components";

export const Border = styled.div`
  border-top-width: 0.5px;
  border-bottom-width: 0.5px;
  border-top-style: dashed;
  border-bottom-style: dashed;
  border-top-color: rgba(69, 98, 157, 0.5);
  border-bottom-color: rgba(69, 98, 157, 0.5);
`;

export const Text = styled.span<{
  $fontSize?: string;
  $color?: string;
  $lineHeight?: string;
  $whiteSpace?: string;
  $wordSpace?: string;
  $wordBreak?: string;
  $fontWeight?: number;
  $mb?: string;
  $mt?: string;
}>`
  font-weight: ${(props) => props.$fontWeight || 400};
  font-size: ${(props) => props.$fontSize};
  color: ${(props) => props.$color};
  line-height: ${(props) => props.$lineHeight};
  white-space: ${(props) => props.$whiteSpace ?? "normal"};
  margin-bottom: ${(props) => props.$mb};
  margin-top: ${(props) => props.$mt};
  word-break: ${(props) => props.$wordBreak ?? "normal"};
`;

export const SpaceBetweenBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const VerticalAlignmentBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FlexEndBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ActionButton = styled.div`
  background-color: #fff;
  padding: 10px 16px;
`;

export const MaterialBox = styled.div`
  border-radius: 4px;
  padding: 8px 14px 20px 14px;
  margin-bottom: 12px;
  background: linear-gradient(
    135deg,
    rgba(65, 127, 255, 0.1) 0%,
    rgba(65, 95, 157, 0.05) 100%
  );
  .normal_text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    white-space: nowrap;
  }
`;

export const MaterialHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 10px 0;

  .material_code {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }

  .material_header-delIcon {
    width: 16px;
    height: 16px;
  }
`;

export const MaterialInfo = styled(Border)`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  .material_name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
  .material_info {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #9ea1a7;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    margin-top: 8px;
  }
  .material_header-delIcon {
    width: 16px;
    height: 16px;
  }
`;

export const MaterialHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;
export const MaterialTarget = styled.div`
  .material_target-input {
    display: inline-block;
    border-radius: 4px;
    border: 1px solid #dfe0e2;
    padding: 10px 0;
    margin-top: 20px;
    input {
      padding: 0 10px;
    }
  }
`;

export const MaterialTargetPicker = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MaterialBottom = styled.div`
  padding-top: 14px;
`;
